const variableMixin = {
  data() {
    return {
      statusArr: [
        { value: 0, label: this.$t('草稿') },
        { value: 1, label: this.$t('待审核') },
        { value: 2, label: this.$t('已发布') },
        { value: 3, label: this.$t('未通过') },
        { value: 4, label: this.$t('取消审核') }
      ],
      positionArr: [
        { value: 1, label: this.$t('首页') },
        { value: 2, label: this.$t('厨社区') }
      ]
    }
  }
}
export default variableMixin
